import { InputNumber, InputPinCode, Loading, PopupWraper } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { MainRouteKeys } from 'routes/enums';
import {
  useCheckPinCodeMutation,
  useWalletTransferMutation,
  useGetBalanceQuery,
} from 'services';
import { getUserInfo } from 'utils/helpers';

import { formSchema, formSchemaPinCode } from './config';

const DepositRewardFromPointFeature = (): JSX.Element => {
  const [isShowPopup, setIsShowPopup] = useState<boolean>(false);

  const navigator = useNavigate();

  const {
    mutateAsync: mutateAsyncCheckPinCode,
    isLoading: isLoadingCheckPinCode,
  } = useCheckPinCodeMutation();

  const { mutateAsync: mutateAsyncTransfer, isLoading } =
    useWalletTransferMutation();

  const { refetch: refetchBalance } = useGetBalanceQuery();

  const { handleSubmit, getInputProps, getValue } = useForm({
    structure: formSchema,
    onSubmit: () => setIsShowPopup(true),
  });

  const { handleSubmit: handleSubmitModal, getInputProps: getInputPropsModal } =
    useForm({
      structure: formSchemaPinCode,
      onSubmit: handleCheckPinCode,
    });

  async function handleCheckPinCode(values: any) {
    const { pinCode } = values;

    const { id: fundId } = getUserInfo();

    const amount = getValue('amount');

    try {
      const dataCheckPinCode = await mutateAsyncCheckPinCode({ pinCode });

      if (!dataCheckPinCode?.isValid) {
        dataCheckPinCode?.message?.map((item: string) => toast.error(item));
      }
      if (dataCheckPinCode && dataCheckPinCode?.isValid) {
        const dataTransfer = await mutateAsyncTransfer({
          toUserId: '',
          amount,
          reason: '',
          pinCode,
          fundId,
        });

        if (dataTransfer && dataTransfer?.statusCode === 200) {
          refetchBalance();
          setIsShowPopup(false);
          toast.success('Nạp Điểm thưởng thành công');
          navigator(MainRouteKeys.Balance);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <div className='row'>
        <div className='col-md-6 balance-management'>
          <div className='balance-management__title'>Nạp điểm thưởng</div>

          <form onSubmit={handleSubmit}>
            <Loading
              isLoading={isLoading}
              className='row justify-content-center balance-management__form'
            >
              <div className='col-md-8'>
                <InputWraper
                  label='Số điểm'
                  component={InputNumber}
                  inputProps={getInputProps('amount')}
                />
              </div>

              <div className='col-12 balance-management__form--btn'>
                <Button
                  type='submit'
                  isLoading={isLoading}
                  disabled={!getValue('amount')}
                  buttonType='success'
                  label='Chuyển điểm'
                />
              </div>
            </Loading>
          </form>
        </div>
      </div>

      {isShowPopup && (
        <PopupWraper
          center
          title='Nhập mật khẩu'
          onClose={() => setIsShowPopup(false)}
        >
          <form onSubmit={handleSubmitModal} className='charge-bill-container'>
            <Loading isLoading={isLoading || isLoadingCheckPinCode}>
              <div className='charge-bill__title'>
                <InputWraper
                  label='Mật khẩu'
                  inputProps={getInputPropsModal('pinCode')}
                  component={InputPinCode}
                />
              </div>
              <div className='charge-bill__button-container'>
                <Button
                  className='button__confirm'
                  label='Xác nhận'
                  buttonType='success'
                  type='submit'
                />
                <Button
                  className='button__cancel'
                  onClick={() => setIsShowPopup(false)}
                  label='Trở về'
                  buttonType='primary-outline'
                />
              </div>
            </Loading>
          </form>
        </PopupWraper>
      )}
    </>
  );
};

export default DepositRewardFromPointFeature;
